import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'warn' | 'error';

export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
  /** 跳转链接，点击时跳转（可选） */
  actionLabel?: string;
  to?: string;
  /** 毫秒后自动消失，默认 3000 */
  ttlMs?: number;
}

interface ToastStore {
  items: ToastItem[];
  push: (t: Omit<ToastItem, 'id'>) => number;
  dismiss: (id: number) => void;
  clear: () => void;
}

let nextId = 1;
export const useToastStore = create<ToastStore>((set, get) => ({
  items: [],
  push: (t) => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { ...t, id }] }));
    const ttl = t.ttlMs ?? 3000;
    if (ttl > 0) setTimeout(() => get().dismiss(id), ttl);
    return id;
  },
  dismiss: (id) =>
    set((s) => ({ items: s.items.filter((x) => x.id !== id) })),
  clear: () => set({ items: [] }),
}));

/** 简化的 push 接口 */
export function toast(t: Omit<ToastItem, 'id'>) {
  return useToastStore.getState().push(t);
}
